import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Tooltip } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { AddonsCartButton } from "app/components/AddonsCart/AddonsCartButton/AddonsCartButton";
import { ExplorePlansButton } from "app/marketing/components/ExplorePlansButton/ExplorePlansButton";
import { headerDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import { UserPackage } from "app/pages/activation/components/UserPackage/UserPackage";
import { activationTracking } from "app/pages/activation/services/tracking";
import { useUserInvitation } from "app/pages/digital-suite/home-page/components/InviteUsers/UseUserInvitation";

import * as SC from "./styles";
import { USERS_ICON_TOOLTIP, WELCOME_TEXT } from "./texts";

export const Header = () => {
    const name = swSettings?.user?.firstname as string;
    const { translate } = useTranslate();
    const { invitationModalComponent, handleOpenModal: inviteTeammate } = useUserInvitation({
        hasAvailableAllocations: true,
    });

    const track = activationTracking.homePageWithData;

    const onUsersClick = () => {
        track.trackInviteTeammates();
        inviteTeammate();
    };

    return (
        <>
            {invitationModalComponent}

            <SC.Container data-automation={headerDataAutomation.container}>
                <SC.UserName
                    fontVariant="h5_2"
                    data-automation={headerDataAutomation.userName}
                >
                    {translate(WELCOME_TEXT, { name })}
                </SC.UserName>

                <SC.ActionsContainer data-automation={headerDataAutomation.actionsContainer}>
                    <AddonsCartButton />
                    <Tooltip
                        content={translate(USERS_ICON_TOOLTIP)}
                        placement="bottom"
                    >
                        <IconButton
                            iconColor={colorsPalettes.blue[400]}
                            iconSize="sm"
                            iconName="users"
                            type="flat"
                            onClick={onUsersClick}
                            onMouseEnter={track.trackInviteTeammatesHover}
                            data-automation={headerDataAutomation.usersIcon}
                        />
                    </Tooltip>
                    <ExplorePlansButton />
                    <UserPackage
                        buttonType="outlined"
                        onClick={track.trackManagePlan}
                        dataAutomation={headerDataAutomation.usersPackage}
                    />
                </SC.ActionsContainer>
            </SC.Container>
        </>
    );
};
